import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {
    $('#logoAndNav').hide();

$(".remove-listingfrom-shortlist").on("click", function () {
    var lp_id = $(this).data("lp-id");
    var action="remove";
    var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
    
    $.ajax({
      type: "POST",
      url: url,
      data: {
        lp_id: lp_id, action:action
      },
      dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
        $('#listingcount').empty();
        $('#listingcount').text(parseInt(mString) + " Listings");  
        $("#mainlisting"+ lp_id).hide(); 
        $('#savedcount').empty();
        $('#savedcount').text(parseInt(mString));             
      },
    });
  });

  $(".remove-searchfrom-listing").on("click", function () {
    var lp_workplace_setting = $(this).data("lp-workplace-setting");
    var lp_learner_interest = $(this).data("lp-learner-interest");
    var lp_level_of_knowledge = $(this).data("lp-level-of-knowledge");
    var lp_occupation_type = $(this).data("lp-occupation-type");
    var key = $(this).data("lp-key");
    var action="removesearch";
    $("#search" + key).hide();

    var url = ajaxdta.ajaxurl + "?action=add_to_searchlpcart";

    $.ajax({
      type: "POST",
      url: url,
      data: {
        action:action,lp_workplace_setting: lp_workplace_setting, lp_learner_interest: lp_learner_interest, lp_level_of_knowledge:lp_level_of_knowledge, lp_occupation_type: lp_occupation_type
      },
      dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
        $('#searchcount').empty();
        $('#searchcount').text(parseInt(mString) + " Searches");
      },
    });
  });

},
};


// WEBPACK FOOTER //
// ./scripts/routes/lp-shortlist.js